import React, { Fragment, useEffect, useState } from "react";
import {
  Box,
  Button,
  Collapse,
  Grid,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Avatar,
  Tooltip,
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  Logout as LogoutIcon,
} from "@mui/icons-material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Colors from "assets/Style/Colors";
import { FontFamily, Images, SvgIcon } from "assets";
import { useAuth } from "context/UseContext";
import InputField from "components/Input";
import SimpleDialog from "components/Dialog/SimpleDialog";
import ConfirmationDialog from "components/Dialog/ConfirmationDialog";
import { PrimaryButton } from "components/Buttons";
import ClientServices from "services/Client";
import SystemServices from "services/System";
import AuthServices from "services/Auth";
import { ErrorToaster } from "components/Toaster";

function Sidebar({ onClick, status }) {
  const navigate = useNavigate();
  const { user, userLogout } = useAuth();
  const { pathname } = useLocation();

  const { register, handleSubmit, getValues } = useForm();
  const { navigation } = useSelector((state) => state.navigationReducer);
  console.log(navigation, 'navigationnavigation');

  const [expand, setExpand] = useState([]);
  const [vinDialog, setVinDialog] = useState(false);
  const [vin, setVin] = useState([]);
  const [lot, setLot] = useState([]);
  const [confirmationDialog, setConfirmationDialog] = useState(false);
  const [website, setWebsite] = useState(null)

  const getData = async (search) => {
    try {
      const { data } = await SystemServices.getCompanyDetail()
      console.log(data);
      setWebsite(data?.company?.website)
      localStorage.setItem("companyWebsite", JSON.stringify(data?.company))


    } catch (error) {
      ErrorToaster(error)
    }
  }

  const handleLogout = async () => {
    try {
      const obj = {
        fcm_token: localStorage.getItem("fcmToken"),
      };
      await AuthServices.handleLogout(obj);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const myNavigation = [
    {
      name: "dashboard",
      icon: "home",
      route: "/dashboard",
      userType: "",
      childRoute: [""],
    },
  ];

  const subCustomer = [
    {
      name: "My Customers",
      route: "/my-customers",
      icon: "customer",
      userType: "",
      childRoute: [""],
      children: [],
    },
    {
      name: "My Vehicles",
      route: "/my-vehicles",
      icon: "vehicle",
      userType: "",
      childRoute: [""],
      children: [],
    },
  ];

  const getWebTokens = async () => {
    try {
      const { data } = await SystemServices.getWebTokens();
      localStorage.setItem("financeToken", data?.financeToken);
      localStorage.setItem("vccToken", data?.vccToken);
      localStorage.setItem("operationsToken", data?.operationsToken);
      localStorage.setItem("searchToken", data?.searchToken);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleCollapse = (value) => {
    const isExpanded = expand.includes(value);
    setExpand(isExpanded ? [] : [value]);
  };

  const handleSubChildActive = (item) => {
    return (
      item.childRoute?.indexOf(pathname) !== -1 &&
      item.childRoute?.indexOf(pathname)
    );
  };

  useEffect(() => {
    getWebTokens();
  }, []);

  const handleClick = () => setVinDialog(true);

  const getVin = async (search) => {
    try {
      let params = { page: 1, limit: 50, search };
      const { data } = await ClientServices.getTTVin(params);

      const vins = data?.details?.vins.map((item) => ({
        id: item.vin,
        name: item.vin,
        ...item,
      }));

      const lots = data?.details?.lots.map((item) => ({
        id: item.lot,
        name: item.lot,
        ...item,
      }));

      setVin([...vins, ...lots]);
      setLot(lots);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const applyFilter = async () => {
    try {
      const search = getValues("search");
      const params = { page: 1, limit: 15, search };
      const { data } = await ClientServices.getVehicleTT(params);

      if (data?.details) {
        navigate(`/vehicle-booking-detail/${data?.details?.id}`);
        setVinDialog(false);
      } else {
        ErrorToaster("No Vehicle Found");
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  useEffect(() => {
    getData()
  }, [])

  return (
    <>
      {/* ========== Confirmation Dialog ========== */}
      <ConfirmationDialog
        open={confirmationDialog}
        onClose={() => setConfirmationDialog(false)}
        message="Are you sure you want to logout?"
        action={() => {
          setConfirmationDialog(false);
          userLogout();
          handleLogout();
        }}
      />

      {/* VIN Dialog */}
      <SimpleDialog
        open={vinDialog}
        onClose={() => setVinDialog(false)}
        title={"Search By Vin/Lot"}
      >
        <Box component="form" onSubmit={handleSubmit(applyFilter)}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <InputField
                size={"small"}
                label={"Search"}
                placeholder={"Search"}
                register={register("search")}
              />
            </Grid>
            <Grid item xs={12} sx={{ mt: 2, textAlign: "center" }}>
              <PrimaryButton title="Submit" type="submit" />
            </Grid>
          </Grid>
        </Box>
      </SimpleDialog>

      {/* Sidebar Header */}
      <Collapse in={status} timeout={500}>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Box component="img" src={Images.sidebarLogo} sx={{ width: "180px" }} />
        </Box>
      </Collapse>

      {/* Avatar & User Info */}
      <Collapse in={status} timeout={500}>
        <Box>
          <Box sx={{ display: "flex", justifyContent: "center", mt: "20%" }}>
            <Tooltip title="Visit Website">
              <Avatar
                src={process.env.REACT_APP_IMAGE_BASE_URL + user?.picture}
                sx={{ width: 60, height: 60, cursor: 'pointer' }}
                onClick={() => window.open(website, '_blank')}
              />
            </Tooltip>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Typography
              variant="body2"
              sx={{ color: Colors.white, fontWeight: 300, fontSize: "18px" }}
            >
              {user?.name}
            </Typography>
          </Box>
          {/* <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 1,
              mt: 2,
            }}
          >
            <Typography
              variant="body2"
              sx={{ color: Colors.white, fontWeight: 300 }}
            >
              {user?.user_type === "A"
                ? "Admin ID"
                : user?.user_type === "S"
                  ? "Staff ID"
                  : "Customer ID"}
            </Typography>
            <Typography variant="body2" sx={{ color: Colors.white }}>
              {user?.ref_id}
            </Typography>
          </Box> */}
        </Box>
      </Collapse>

      <List>
        {user?.user_type == "C" ?
          <ListItemButton
            component={Link}
            to={'/dashboard'}
            aria-label={'dashboard'}
            sx={{
              borderRadius: 2,
              px: 1,
              py: 0,
              mt: 1.5,
              bgcolor: '/dashboard' === pathname ? Colors.primary : "",
              fontWeight: '/dashboard' === pathname ? 'bold' : "",
              boxShadow: status ? '/dashboard' === pathname ? "0px 4px 5px 0px #B8B8B840" : "" : "",
              "&:hover": {
                bgcolor: Colors.primary,
                ".MuiTypography-root": {
                  color: Colors.white,
                },
                ".MuiListItemIcon-root": {
                  bgcolor: "transparent",
                },
                svg: {
                  path: {
                    fill: Colors.white,
                  },
                },
              },
            }}
          >
            <ListItemIcon
              dangerouslySetInnerHTML={{ __html: SvgIcon['home'] }}
              sx={{


                minWidth: "auto",
                mr: 1,
                borderRadius: "6px",
                p: "10px",
                svg: {
                  height: "20px",
                  width: "20px",
                  path: {
                    fill: '/dashboard' === pathname ? Colors.white : "",
                  },
                },
              }}
            ></ListItemIcon>
            {status && <ListItemText
              primary={
                <Typography
                  variant="body2"
                  sx={{
                    transition: 'all 0.3s ease-in-out',
                    textTransform: "capitalize",
                    fontFamily: FontFamily.NunitoRegular,
                    color: '/dashboard' === pathname ? Colors.white : Colors.white,
                  }}
                >
                  Dashboard
                </Typography>
              }
            />}
          </ListItemButton> :
          myNavigation?.map((item, index) => (
            <Fragment key={index}>
              <ListItemButton
                key={index}
                component={item.route ? Link : "div"}
                to={item.route ?? ""}
                aria-label={item?.name}
                onClick={() => {
                  item.childRoute && handleCollapse(item.name);
                }}
                sx={{
                  borderRadius: 2,
                  px: 1,
                  py: 0,
                  mt: 1.5,
                  bgcolor:
                    item.route === pathname ||
                      handleSubChildActive(item) ||
                      handleSubChildActive(item) === 0
                      ? Colors.primary
                      : "",
                  boxShadow:
                    item.route === pathname ||
                      handleSubChildActive(item) ||
                      handleSubChildActive(item) === 0
                      ? "0px 4px 5px 0px #B8B8B840"
                      : "",
                  "&:hover": {
                    bgcolor: Colors.primary,
                    ".MuiTypography-root": {
                      color: Colors.white,
                    },
                    ".MuiListItemIcon-root": {
                      bgcolor: "transparent",
                    },
                    svg: {
                      path: {
                        fill: Colors.white,
                      },
                    },
                  },
                }}
              >
                <ListItemIcon
                  dangerouslySetInnerHTML={{ __html: SvgIcon[item.icon] }}
                  sx={{
                    bgcolor:
                      item.route === pathname ||
                        handleSubChildActive(item) ||
                        handleSubChildActive(item) === 0
                        ? "transparent"
                        : "transparent",
                    // boxShadow: "0px 4px 5px 0px #B8B8B840",
                    minWidth: "auto",
                    mr: 1,
                    borderRadius: "6px",
                    p: "10px",
                    svg: {
                      height: "20px",
                      width: "20px",
                      path: {
                        fill:
                          item.route === pathname ||
                            handleSubChildActive(item) ||
                            handleSubChildActive(item) === 0
                            ? Colors.white
                            : Colors.white,
                      },
                    },
                  }}
                ></ListItemIcon>

                {status && <ListItemText
                  primary={
                    <Typography
                      variant="body2"
                      sx={{
                        transition: 'all 0.3s ease-in-out',
                        textTransform: "capitalize",
                        fontFamily: FontFamily.NunitoRegular,
                        color:
                          item.route === pathname ||
                            handleSubChildActive(item) ||
                            handleSubChildActive(item) === 0
                            ? Colors.white
                            : Colors.white,
                      }}
                    >
                      {item.name}
                    </Typography>
                  }
                />}
                {item?.children &&
                  (expand.indexOf(item.name) !== -1 ||
                    item.childRoute?.indexOf(pathname) !== -1 ? (
                    <ExpandLess
                      size="small"
                      sx={{
                        color:
                          item.route === pathname ||
                            handleSubChildActive(item) ||
                            handleSubChildActive(item) === 0
                            ? Colors.white
                            : Colors.white,
                      }}
                    />
                  ) : (
                    <ExpandMore size="small" sx={{ color: Colors.white }} />
                  ))}
              </ListItemButton>
              {item?.children && (
                <Collapse
                  in={
                    expand.indexOf(item.name) !== -1 ||
                      item.childRoute?.indexOf(pathname) !== -1
                      ? true
                      : false
                  }
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {item.children.map((child, i) => (
                      <ListItemButton
                        key={i}
                        component={child.route ? Link : "div"}
                        to={child.route ?? ""}
                        aria-label={child?.name}
                        onClick={() => {
                          child.route && handleCollapse(child.name);
                        }}
                        sx={{
                          borderRadius: 2,
                          px: 1,
                          py: 0.5,
                          mt: 0.5,
                          ml: "48px",
                          "&:hover": {
                            ".MuiTypography-root": {
                              color: Colors.white,
                            },
                          },
                        }}
                      >
                        {status && <ListItemText onClick={child?.name == "Search Vin/Lot" ? handleClick : () => { }}
                          primary={
                            <Typography
                              variant="body2"
                              sx={{
                                textTransform: "capitalize",
                                fontFamily: FontFamily.NunitoRegular,
                                color:
                                  child.route === pathname ||
                                    handleSubChildActive(child) ||
                                    handleSubChildActive(child) === 0
                                    ? Colors.white
                                    : Colors.white,
                                fontWeight: child.route === pathname ||
                                  handleSubChildActive(child) ||
                                  handleSubChildActive(child) === 0
                                  ? "bold"
                                  : "",
                              }}
                            >
                              {child.name}
                            </Typography>
                          }
                        />}
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
              )}
            </Fragment>
          ))}

        {user?.user_type == "C" && user?.customer_type_id == 3 && user?.journey?.request?.status == "Completed" && subCustomer.map((item, index) => (


          <Fragment key={index}>

            <ListItemButton
              key={index}
              component={item.route ? Link : "div"}
              to={item.route ?? ""}
              aria-label={item?.name}
              onClick={() => {
                item.childRoute && handleCollapse(item.name);
              }}
              sx={{
                borderRadius: 2,
                px: 1,
                py: 0,
                mt: 1.5,
                bgcolor: item?.route === pathname ? Colors.primary : "",
                boxShadow: item?.route === pathname ? "0px 4px 5px 0px #B8B8B840" : "",



              }}
            >
              <ListItemIcon
                dangerouslySetInnerHTML={{ __html: SvgIcon[item.icon] }}
                sx={{

                  // boxShadow: "0px 4px 5px 0px #B8B8B840",
                  minWidth: "auto",
                  mr: 1,
                  borderRadius: "6px",
                  p: "10px",
                  svg: {
                    height: "20px",
                    width: "20px",
                    path: {
                      fill:
                        item.route === pathname ||
                          handleSubChildActive(item) ||
                          handleSubChildActive(item) === 0
                          ? Colors.white
                          : "",
                    },
                  },
                }}
              ></ListItemIcon>

              {status && <ListItemText
                primary={
                  <Typography
                    variant="body2"
                    sx={{
                      transition: 'all 0.3s ease-in-out',
                      textTransform: "capitalize",
                      fontFamily: FontFamily.NunitoRegular,
                      color:
                        item.route === pathname ||
                          handleSubChildActive(item) ||
                          handleSubChildActive(item) === 0
                          ? Colors.white
                          : Colors.white,
                      fontWeight:
                        item.route === pathname
                          ? "bold"
                          : '',
                    }}
                  >
                    {item.name}
                  </Typography>
                }
              />}

            </ListItemButton>
            {item?.children && (
              <Collapse
                in={
                  expand.indexOf(item.name) !== -1 ||
                    item.childRoute?.indexOf(pathname) !== -1
                    ? true
                    : false
                }
                timeout="auto"
                unmountOnExit
              >
                <List component="div" disablePadding>
                  {item.children.map((child, i) => (
                    <ListItemButton
                      key={i}
                      component={child.route ? Link : "div"}
                      to={child.route ?? ""}
                      aria-label={child?.name}
                      onClick={() => {
                        child.route && handleCollapse(child.name);
                      }}
                      sx={{
                        borderRadius: 2,
                        px: 1,
                        py: 0.5,
                        mt: 0.5,
                        ml: "48px",
                        "&:hover": {
                          ".MuiTypography-root": {
                            color: Colors.white,
                          },
                        },
                      }}
                    >
                      {status && <ListItemText
                        primary={
                          <Typography
                            variant="body2"
                            sx={{
                              transition: 'all 0.3s ease-in-out',
                              textTransform: "capitalize",
                              fontFamily: FontFamily.NunitoRegular,
                              color:
                                child.route === pathname ||
                                  handleSubChildActive(child) ||
                                  handleSubChildActive(child) === 0
                                  ? Colors.white
                                  : Colors.white,
                              fontWeight: child.route === pathname ||
                                handleSubChildActive(child) ||
                                handleSubChildActive(child) === 0
                                ? 'bold' : ''
                            }}
                          >
                            {child.name}
                          </Typography>
                        }
                      />}
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            )}
          </Fragment>
        ))}
        { [...navigation]
          .sort((a, b) => (a.order_by ?? 0) - (b.order_by ?? 0))
          .map((item, index) => (
            <Fragment key={index}>
              <ListItemButton
                key={index}
                component={item.route ? Link : "div"}
                to={item.route ?? ""}
                aria-label={item?.name}
                onClick={() => {
                  item.childRoute && handleCollapse(item.name);
                }}
                sx={{
                  borderRadius: 2,
                  px: 1,
                  py: 0,
                  mt: 1.5,
                  bgcolor:
                    item.route === pathname ||
                      handleSubChildActive(item) ||
                      handleSubChildActive(item) === 0
                      ? Colors.primary
                      : "",
                  boxShadow:
                    item.route === pathname ||
                      handleSubChildActive(item) ||
                      handleSubChildActive(item) === 0
                      ? "0px 4px 5px 0px #B8B8B840"
                      : "",
                  "&:hover": {
                    bgcolor: Colors.primary,
                    ".MuiTypography-root": {
                      color: Colors.white,
                    },
                    ".MuiListItemIcon-root": {
                      bgcolor: "transparent",
                    },
                    svg: {
                      path: {
                        fill: Colors.white,
                      },
                    },
                  },
                }}
              >
                <ListItemIcon
                  dangerouslySetInnerHTML={{ __html: SvgIcon[item.icon] }}
                  sx={{
                    bgcolor:
                      item.route === pathname ||
                        handleSubChildActive(item) ||
                        handleSubChildActive(item) === 0
                        ? "transparent"
                        : 'transparent',
                    // boxShadow: "0px 4px 5px 0px #B8B8B840",
                    minWidth: "auto",
                    mr: 1,
                    borderRadius: "6px",
                    p: "10px",
                    svg: {
                      height: "20px",
                      width: "20px",
                      path: {
                        fill:
                          item.route === pathname ||
                            handleSubChildActive(item) ||
                            handleSubChildActive(item) === 0
                            ? Colors.white
                            : "",
                      },
                    },
                  }}
                ></ListItemIcon>

                {status && <ListItemText
                  primary={
                    <Typography
                      variant="body2"
                      sx={{
                        transition: 'all 0.3s ease-in-out',
                        textTransform: "capitalize",
                        fontFamily: FontFamily.NunitoRegular,
                        color:
                          item.route === pathname ||
                            handleSubChildActive(item) ||
                            handleSubChildActive(item) === 0
                            ? Colors.white
                            : Colors.white,
                      }}
                    >
                      {item.name}
                    </Typography>
                  }
                />}
                {item?.children &&
                  (expand.indexOf(item.name) !== -1 ||
                    item.childRoute?.indexOf(pathname) !== -1 ? (
                    <ExpandLess
                      size="small"
                      sx={{
                        color:
                          item.route === pathname ||
                            handleSubChildActive(item) ||
                            handleSubChildActive(item) === 0
                            ? Colors.white
                            : Colors.white,
                      }}
                    />
                  ) : (
                    <ExpandMore size="small" sx={{ color: Colors.white }} />
                  ))}
              </ListItemButton>
              {item?.children && (
                <Collapse
                  in={
                    expand.indexOf(item.name) !== -1 ||
                      item.childRoute?.indexOf(pathname) !== -1
                      ? true
                      : false
                  }
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {item.children.map((child, i) => (
                      <ListItemButton
                        key={i}
                        component={child.route ? Link : "div"}
                        to={child.route ?? ""}
                        aria-label={child?.name}
                        onClick={() => {
                          child.route && handleCollapse(child.name);
                        }}
                        sx={{
                          borderRadius: 2,
                          px: 1,
                          py: 0.5,
                          mt: 0.5,
                          ml: "48px",
                          "&:hover": {
                            ".MuiTypography-root": {
                              color: Colors.white,
                            },
                          },
                        }}
                      >
                        {status && <ListItemText
                          primary={
                            <Typography
                              variant="body2"
                              sx={{
                                transition: 'all 0.3s ease-in-out',
                                textTransform: "capitalize",
                                fontFamily: FontFamily.NunitoRegular,
                                color:
                                  child.route === pathname ||
                                    handleSubChildActive(child) ||
                                    handleSubChildActive(child) === 0
                                    ? Colors.white
                                    : Colors.white,
                                fontWeight: child.route === pathname ||
                                  handleSubChildActive(child) ||
                                  handleSubChildActive(child) === 0
                                  ? 'bold' : ''
                              }}
                            >
                              {child.name}
                            </Typography>
                          }
                        />}
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
              )}
            </Fragment>
          ))}

      </List>

      {/* Logout Button */}
      <Collapse in={status} timeout={500}>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Button
            variant="contained"
            onClick={() => setConfirmationDialog(true)}
            sx={{
              backgroundColor: "white",
              color: Colors.primary,
              textTransform: "none",
              borderRadius: "12px",
              p: "9px 17px",
              ":hover": {
                backgroundColor: Colors.primary,
                color: "white",
              },
            }}
          >
            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
              <LogoutIcon sx={{ fontSize: 20 }} />
              Logout
            </Box>
          </Button>
        </Box>
      </Collapse>
    </>
  );
}

export default Sidebar;
